(function(document, window, $) {
  'use strict';

  var Site = window.Site;

  $(document).ready(function($) {
    Site.run();



      /*
       * DROPZONE
       */

      window.initDropzone = function(target = '.mdropzone') {


          if ($(target).length)
              $(target).each(addDropzoneEvent);


          function addDropzoneEvent() {

             // console.log("init dropzone");
              var concat = '?';
              //TODO change the way we get-send token
              var field=$(this).attr('data-field');
              var customformat = $(this).attr('data-customformat');
              var agency = $(this).attr('data-agency');
              var addon ='';
              if (agency!=undefined) addon = '&agency='+agency;
              var types=$(this).attr('data-types');

              var url=$(this).attr('data-url')+concat+'component='+$(this).attr('data-component')+'&customformat='+customformat+'&field='+field+'&types='+types+addon+'&_token='+$('meta[name="csrf-token"]').attr('content');
              var id = $(this).attr('id');
              var preview = $(this).attr('data-preview');
              var mode = $(this).attr('data-mode');
              var message = $(this).data('message');
              if (message == undefined) message = 'DROP FILES HERE TO UPLOAD';

              var $target = $(this);


              var customCall = $(this).attr('data-custom-call');
              var dz = $('#' + id).dropzone({
                  url: url,
                  autoProcessQueue: true,
                  uploadMultiple: true,
                  parallelUploads: 1,
                  maxFiles: 100,
                  maxFilesize: 600,
                  addRemoveLinks: true,
                  dictDefaultMessage: '<i class="icon ti-cloud-up"></i> '+message,
                  init: function () {

                      var mdropzone = this;
                      var count = 0;

                      this.on("success", function (file, responseText) {
                          //for single image
                          if (mode == 'single') {
                              if (preview != undefined)
                                  $('#' + preview).attr('src', responseText['filename']);
                                 $('#' + field).val(responseText['filename']);

                              if (responseText['value'] != undefined)
                                  $('#' + field).val(responseText['value']);

                              if (customCall != undefined)
                                  window[customCall](responseText['filename'], responseText['template']);

                              if (responseText['fillintext'] != undefined) window.fillintext(responseText['fillintext']);

                          } else {
                              //for multiple images
                              if (customCall != undefined) {
                                  window[customCall](responseText['filename'], responseText['template']);
                              } else {
                                  // addMultiPreviewFile(preview, responseText['filename']);
                                  //$('#' + preview).append(responseText['template']);
                                  addMultiPreviewTemplate(preview, responseText['template']);
                              }
                          }

                          $(file.previewTemplate).remove();
                          count--;
                          if (count==0){
                              $target.removeClass('dz-started');
                          }
                      });

                      this.on("addedfile", function (file) {
                          // console.log("Added file.");
                          count++;
                      });

                      this.on("removedfile", function (file) {
                        //  console.log("removedfile file:");
                          //console.log(file);
                          count--;
                      });

                      this.on("processingfile", function (file) {
                          //mdropzone.options.url = "/some-other-url";
                          //console.log("Process");
                      });

                      this.on("error", function (file) {
                          inMessageError("Error uploading file");
                          $(file.previewTemplate).remove();
                          count--;
                      });


                  }

              });
          }
      }

      window.initDropzone();


  });

    window.addMultiPreviewTemplate = function(target, template){
        $('#'+target).append(template);
        $('.sortable').sortable();
    };

   // window.addMultiPreviewFile()

    Dropzone.autoDiscover = false;

})(document, window, jQuery);
